"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    filterMenuVariants: ()=>filterMenuVariants,
    mobileVariants: ()=>mobileVariants,
    rowVariants: ()=>rowVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const mobileVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        cell: '',
        describe: '',
        resizer: ''
    },
    variants: {
        hide: {
            true: {
                describe: 'hidden'
            }
        },
        breakpoint: {
            sm: {
                cell: 'hidden sm:table-cell',
                describe: 'sm:hidden'
            },
            md: {
                cell: 'hidden md:table-cell',
                describe: 'md:hidden'
            },
            lg: {
                cell: 'hidden lg:table-cell',
                describe: 'lg:hidden'
            }
        },
        resize: {
            true: {
                resizer: 'user-select-none touch-action-none hover:bg-neutral-2 absolute right-0 top-0 h-[100%] w-[5px] cursor-col-resize'
            }
        },
        isResizing: {
            true: {
                resizer: 'bg-primary-3'
            }
        }
    },
    defaultVariants: {
        breakpoint: void 0,
        hide: false,
        resize: false,
        isResizing: false
    }
});
const rowVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        panel: [
            'data-[ending-style]:h-0 data-[starting-style]:h-0',
            'data-[ending-style]:py-0 data-[starting-style]:py-0',
            'data-[ending-style]:border-b-0 data-[starting-style]:border-b-0',
            '[&[data-ending-style]>div]:h-0 [&[data-starting-style]>div]:h-0',
            'overflow-hidden',
            'data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
            'h-[var(--collapsible-panel-height)]',
            '[transition-duration:var(--transition-duration-long)]'
        ]
    }
});
const filterMenuVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        popupItem: [
            'flex min-h-[40px] w-full items-center justify-between gap-[12px] rounded-lg px-[12px] py-[8px]',
            'focus-visible:outline-primary-8 [&:hover,&:focus]:bg-primary-2 hover:cursor-pointer hover:outline-none focus-visible:outline focus-visible:outline-2'
        ],
        itemLabelWrapper: 'text-primary-13',
        itemLabel: 'text-body2 whitespace-nowrap',
        itemSelectedIconWrapper: 'flex h-[20px] w-[20px]'
    },
    variants: {
        itemSelected: {
            true: {
                popupItem: 'bg-primary-4 [&:hover,&:focus]:bg-primary-4'
            }
        }
    }
});
exports.filterMenuVariants = __webpack_exports__.filterMenuVariants;
exports.mobileVariants = __webpack_exports__.mobileVariants;
exports.rowVariants = __webpack_exports__.rowVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "filterMenuVariants",
    "mobileVariants",
    "rowVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
